import apiClient from './apiClient'

export interface ImportRowMessage {
  type: 'error' | 'warning'
  text: string
}

export interface ImportRowResult {
  rowNumber: number
  name: string
  action: 'created' | 'updated' | 'skipped'
  messages: ImportRowMessage[]
}

export interface ImportResult {
  created: number
  updated: number
  skipped: number
  rows: ImportRowResult[]
}

export const importsService = {
  importEmployees: async (file: File): Promise<ImportResult> => {
    const form = new FormData()
    form.append('file', file)
    const response = await apiClient.post<ImportResult>('/imports/employees', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  importAbsences: async (file: File): Promise<ImportResult> => {
    const form = new FormData()
    form.append('file', file)
    const response = await apiClient.post<ImportResult>('/imports/absences', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  importContractors: async (file: File): Promise<ImportResult> => {
    const form = new FormData()
    form.append('file', file)
    const response = await apiClient.post<ImportResult>('/imports/contractors', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  importPensionContributions: async (file: File): Promise<ImportResult> => {
    const form = new FormData()
    form.append('file', file)
    const response = await apiClient.post<ImportResult>('/imports/pension-contributions', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  importLmsResults: async (file: File): Promise<LmsImportResult> => {
    const form = new FormData()
    form.append('file', file)
    const response = await apiClient.post<LmsImportResult>('/imports/lms', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },
}

export interface LmsDocumentSummary {
  courseCode: string
  documentName: string
  completedCount: number
  notCompletedCount: number
  createdCount: number
  updatedCount: number
  skippedCount: number
  notFoundCount: number
}

export interface LmsRowResult {
  rowNumber: number
  personName: string
  documentName: string
  courseCode: string
  action: 'created' | 'updated' | 'skipped'
  isCompleted: boolean
  messages: ImportRowMessage[]
}

export interface LmsImportResult {
  created: number
  updated: number
  skipped: number
  notFound: number
  documents: LmsDocumentSummary[]
  rows: LmsRowResult[]
}
